// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tourText[data-v-5bf869d2]{line-height:50%;white-space:nowrap}.md-card[data-v-5bf869d2]{width:150px;margin:4px;display:inline-block;vertical-align:top;background:rgba(48,47,47,.767);border-radius:5px}.infoBox[data-v-5bf869d2],.md-card[data-v-5bf869d2],.md-card-header[data-v-5bf869d2],.md-titel[data-v-5bf869d2]{color:#fff}.infoBox[data-v-5bf869d2]{width:150px;height:60px;border-radius:5px;padding:10px}", ""]);
// Exports
module.exports = exports;
